import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';

/** AngularMaterial **/
import { MatCardModule } from '@angular/material';
import { EstudoCabecalhoComponent } from './estudo-cabecalho.component';
import { EstudoResumoModule } from '../estudo-resumo/estudo-resumo.module';
import { ComparacaoModule } from '../comparacao/comparacao.module';
import { EstudoResumoDialog } from '../estudo-resumo/estudo-resumo.dialog';
import { ComparacaoDialog } from '../comparacao/comparacao.dialog';
import { EstudoDialogComponent } from '../estudo-dialog/estudo-dialog.component';
import { EstudoDialogModule } from '../estudo-dialog/estudo-dialog.module';
import { ObservacaoEstudoModule } from '../observacao-estudo/observacao-estudo.module';
import { ObservacaoEstudoDialog } from '../observacao-estudo/observacao-estudo-dialog';
import { EmailEstudoModule } from '../email-estudo/email-estudo.module';
import { EmailEstudoDialog } from '../email-estudo/email-estudo-dialog';
import { EstudoRenovacaoDialogComponent } from '../estudo-renovacao/estudo-renovacao-dialog.component';
import { EstudoRenovacaoModule } from '../estudo-renovacao/estudo-renovacao.module';

@NgModule({
    declarations: [
      EstudoCabecalhoComponent
    ],
    exports: [
      EstudoCabecalhoComponent
    ],
    imports: [
      FormsModule, CommonModule, EstudoResumoModule, ComparacaoModule, EstudoDialogModule, ObservacaoEstudoModule, EmailEstudoModule,
      MatCardModule, EstudoRenovacaoModule
    ],
    entryComponents: [
      EstudoResumoDialog, ComparacaoDialog, EstudoDialogComponent,ObservacaoEstudoDialog, EmailEstudoDialog, EstudoRenovacaoDialogComponent
    ]
})
export class EstudoCabecalhoModule {

}
